let onTwoFactorRedirectHandler: (() => void) | null = null;

export function setBetterAuthTwoFactorRedirectHandler(handler: (() => void) | null): void {
  onTwoFactorRedirectHandler = handler;
}

export function notifyBetterAuthTwoFactorRedirect(): void {
  onTwoFactorRedirectHandler?.();
}
